import { readStatusRowStack } from '../compile/status-stack-reader.js';
import { statusItemId, statusRows } from './expiry.js';
import { encounterCreatureField } from '../../shared/array-types.js';

type Row = Record<string, unknown>;
export const SHIELDED = 'EB6632D3-5EC0-4E4D-5C6C-1BCB7EF57022';
export const SHIELDED_IDS = new Set([SHIELDED,
  'BF823982-6FC8-51F0-F452-5BE1C949FBA6', '36DA5B89-CA08-3940-E798-FCAE6BE775D5', '8346CCFF-3A5B-F0E4-CFDE-6CF1D1ED3368',
  'E5314BED-1269-3A65-8C15-01E80A3A8E23', 'E614D75F-CF27-D169-3D91-0D33D9CE354B', 'A831D8E0-4DC5-4FBF-4A4C-2C9955AE230A',
  '631AAD91-F6A5-879D-5BD6-B7F885AA7FC9', 'BF1C1C48-8171-90B8-CD83-F2768348629F', '2A63EC91-E5B1-17B4-DFB0-199F9E2084A5',
  '01B0F693-7D8A-C588-9B34-CD1F323D8433']);
export interface ShieldedChange { status_id: string; status_item_id: string; target: string; before: number; status_stack: number }
/** calc_total_damage_and_apply_to_target consumes one barrier per damage application, including an immune hit. */
export function shieldedChanges(target: Row, hits = 1): ShieldedChange[] {
  return statusRows(target, 'target').filter(s => SHIELDED_IDS.has(statusItemId(s))).map(s => {
    const before = readStatusRowStack(s);
    return { status_id: String(s.status_id ?? '').toUpperCase(), status_item_id: statusItemId(s),
      target: String(encounterCreatureField(target.encounter_creatures, 'encounter_creature_id') ?? '').toUpperCase(), before, status_stack: Math.max(0, before - hits) };
  });
}
